import { Button, Icon, Loader, Modal, useModal } from '@afterpaytouch/core'
import React, { FunctionComponent, useEffect } from 'react'
import { useAppDispatch, useCheckoutToken, useIsApplePaylater, useLazyGetCheckoutPpaDocumentQuery } from '../../state'
import styles from './style.module.css'
import { TruthInLendingIframe } from './TruthInLendingIframe'
import { PayMonthlyTILAModalKey } from '../../model/modalKey'

interface TruthInLendingModalProps {
  documentId: string
  isTilDisclosure: boolean
}

export const TruthInLendingModal: FunctionComponent<TruthInLendingModalProps> = ({ documentId, isTilDisclosure }) => {
  const { visible, closeModal } = useModal(PayMonthlyTILAModalKey)
  const [getDocument, { data: documentData, isFetching: lazyDocumentIsLoading }] = useLazyGetCheckoutPpaDocumentQuery()
  const dispatch = useAppDispatch()
  const token = useCheckoutToken()
  const isApplePaylater = useIsApplePaylater()

  useEffect(() => {
    if (!visible || documentId.trim().length === 0) {
      return
    }
    dispatch(async () => await getDocument({ token, docId: documentId }))
  }, [visible, documentId])

  const printDocument = (): void => {
    const documentIframe: HTMLIFrameElement | null = document.querySelector('#document-window')
    if (documentIframe === null || documentIframe.contentWindow === null) {
      return
    }
    documentIframe.contentWindow.print()
  }

  return (
    <Modal id={PayMonthlyTILAModalKey} show={visible} onBackdropClick={closeModal} showCloseButton={visible} testNameSpace='til-document-modal'>
      <div className={styles.iframeModalBtn}>
        {!isApplePaylater && (
          <Button.Link type='button' aria-label='til-print-document-button' onClick={printDocument} disabled={lazyDocumentIsLoading}>
            <Icon.Printer size='Medium' color='Black' />
          </Button.Link>
        )}
        <Button.Link type='button' aria-label='til-close-modal-button' onClick={closeModal}>
          <Icon.Close size='Medium' color='Black' />
        </Button.Link>
      </div>
      {lazyDocumentIsLoading ? <Loader /> : <TruthInLendingIframe documentData={documentData} isTilDisclosure={isTilDisclosure} />}
    </Modal>
  )
}
